import React from 'react'
import MarkdownRenderer from './MarkdownRenderer'

const QuoteBoxMini = ({ quote, quoteName }) => {
  return (
    <>
      {quote && (
        <div className="quotebox-mini has-background-primary has-text-white p-5">
          <MarkdownRenderer
            markdown={quote}
            textClass="ee-quoteline is-size-4 is-family-primary"
            Tag="p"
          />

          {/* <p className='ee-quoteline is-size-4 is-family-primary' dangerouslySetInnerHTML={{ __html: quote }}></p> */}
          <p className="is-uppercase is-size-6 mt-3">{quoteName}</p>
        </div>
      )}
    </>
  )
}

export default QuoteBoxMini
